// extracted by mini-css-extract-plugin
export default {"home":"homeImage_home__vaSHt","img_wr":"homeImage_img_wr__Rncst","wr1":"homeImage_wr1__r9Dr9","wr2":"homeImage_wr2__EgIJ2","button":"homeImage_button__rfLsn"};